"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var styles = {
  "label": "styles-label-3Zc32",
  "control": "styles-control-12Pze",
  "addon": "styles-addon-fHX-H",
  "prepend": "styles-prepend-3yZWC",
  "append": "styles-append-2Bs2q",
  "focus": "styles-focus-29vz3",
  "group": "styles-group-NqOA7"
};
var FormLabel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "htmlFor"]);
  return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
    ref: ref,
    className: _utils.classNames.use(styles.label).join(className),
    htmlFor: htmlFor
  }, htmlProps), children);
});
var _default = FormLabel;
exports["default"] = _default;